var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThLanguage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.290573H30V20.2902H0V0.290573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.66103H30V13.9197H0V6.66103Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.290573H30V3.48522H0V0.290573ZM0 17.0958H30V20.2905H0V17.0958Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "white",
    transform: "translate(0 0.290527)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThLanguage);
export default __webpack_public_path__ + "static/media/thLanguage.8afc7ae693f26cee27aeba73d3cb0312.svg";
export { ForwardRef as ReactComponent };